
import React from 'react';
import { NavLink } from 'react-router-dom';
import './Solution1.css';
import videoSource from '../Assets/solvid.mp4'; // Same video as Product page
import productImage2 from '../Assets/solutionm11.jpg';
import productImage3 from '../Assets/solution12.jpeg';
import productImage4 from '../Assets/solution13.jfif';
import productImage5 from '../Assets/solution14.png';
import productImage6 from '../Assets/solution15.png';
import productImage7 from '../Assets/solution16.png';
import productImage8 from '../Assets/solution17.jpg';
import productImage9 from '../Assets/solution18.jpeg';
import productImage10 from '../Assets/solution19.png';
import productImage11 from '../Assets/solution20.png';
import productImage12 from '../Assets/solution.21.png';
import productImage13 from '../Assets/solution23.png';
import productImage14 from '../Assets/solution24.jpg';
import productImage15 from '../Assets/solution25.jfif';
import productImage16 from '../Assets/solution 26.jpg';
import productImage17 from '../Assets/solution27.jfif';


const Solutions = () => {
  return (
    <div className="solutions-container">
      <div className="video-background">
        <video autoPlay loop muted>
          <source src={videoSource} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* <div className="video-overlay"></div> */}
        <div className="video-content">
          <h1>Our Innovative Solutions</h1>
          <p>Explore our cutting-edge solutions for various industries.</p>
        </div>
      </div>

      {/* Cards section with images */}
      <div className="card-section">
        {[
          { image: productImage2, title: 'Fuel Monitoring System', route:'/Fuel-monitoring' },
          { image: productImage3, title: 'Battery Management Solution', route: '/Battery-management' },
          { image: productImage4, title: 'Aqua/Pond Monitoring', route: '/Aqua' },
          { image: productImage5, title: 'AMR Solution', route: '/AMRS' },
          { image: productImage6, title: 'Prepaid Meter Solution', route: '/Prepaid-meter-solution' },
          { image: productImage7, title: 'Street Light Control Solution', route: '/Street-light-control' },
          { image: productImage8, title: 'Water Quality/Supply Management', route: '/Water-quality-management-solution' },
          { image: productImage9, title: 'Vehicle Tracking System', route: '/Vehicle-Tracking-System' },
          { image: productImage10, title: 'Weather Monitoring', route: '/Weather-Monitoring' },
          { image: productImage11, title: 'Burglar Alarm System', route: '/Burgular-Alarm-System' },
          { image: productImage12, title: 'Energy Monitoring System', route: '/Energy-monitoring-system' },
          { image: productImage13, title: 'Food Chain Industry', route: '/Food-chain-industries' },
                    { image: productImage14, title: 'Fire Detection', route: "/Fire-detection" },
                    { image: productImage15, title: 'PMS for food grade industries', route: "/PMS-for-food-grade-industries" },
                    { image: productImage16, title: 'Telecom Solution', route: "/Telecom" },
                     { image: productImage17, title: 'Green Infra Management', route: "/GIM" },

        ].map((solution, index) => (
          <NavLink key={index} to={solution.route} className="solution-card">
            <img src={solution.image} alt={`Solution ${index + 1}`} className="card-image" />
            <div className="card-content">
              <h2>{solution.title}</h2>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default Solutions;
